import * as React from 'react';

const SummaryTitle = ({ children  })=>/*#__PURE__*/ React.createElement("strong", {
        className: "summary-title"
    }, children)
;

export { SummaryTitle };
//# sourceMappingURL=SummaryTitle.js.map
